import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ffe5590"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Donate", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("p", null, "We'd like to give a big, BIG thank you to everyone that has supported us. Your support helps keep this site free to use and without any adverts."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Please support us by becoming one of our patreons at Patreon "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.patreon.com/booza",
      target: "_blank"
    }, "https://www.patreon.com/booza"),
    /*#__PURE__*/_createTextVNode(".")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Please support us by \"buying us a coffee\" at Ko-fi "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ko-fi.com/booza",
      target: "_blank"
    }, "https://ko-fi.com/booza"),
    /*#__PURE__*/_createTextVNode(".")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://ko-fi.com/booza",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "center",
      style: {"width":"100px"},
      src: "images/kofi-logo.png"
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Alternatively you can also support us with a crypto tip by sending the tip to any of the addresses below."),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "Bitcoin (BTC):"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("pre", null, "bc1qcjldnmdtkx0ukwgf9y3kr6903gaaxg7dkt5a4x")
    ]),
    /*#__PURE__*/_createElementVNode("dt", null, "Ethereum (ETH and DAI, USDT, USDC):"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("pre", null, "0x613f9eb5c05c83613582deaa99619cf2b2f29983")
    ]),
    /*#__PURE__*/_createElementVNode("dt", null, "Doge (DOGE):"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("pre", null, "D6scLQMNyRBtdiFp9A8k3HYH84BS3zLvPP")
    ]),
    /*#__PURE__*/_createElementVNode("dt", null, "Binance Smart Chain (BNB and BUSD):"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("pre", null, "bnb1csy0ssf8mlmx3jytcka92n3afgs46mmtrf9e99")
    ]),
    /*#__PURE__*/_createElementVNode("dt", null, "Avalanche (AVAX):"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("pre", null, "X-avax1v5kejvugx0w4gl7wrjh975ek9zjg80sehjgema")
    ]),
    /*#__PURE__*/_createElementVNode("dt", null, "Fantom (FTM):"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("pre", null, "0xD2fb16A7e97320adEB3E89C340d946c0839a0C6A")
    ])
  ])
], -1))
const _hoisted_3 = { class: "footer-buttons" }
const _hoisted_4 = { class: "clearfix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { onClose: _ctx.onOkay }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _hoisted_2
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "confirmbtn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOkay && _ctx.onOkay(...args)))
          }, "Okay")
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}